import { useRef } from "react";
import { useQuery } from "react-query";

// components
import { HomeScrollContainerHeader } from "components/Home/HomeScrollContainerHeader";

// customHooks
import useCheckEndsReached from "customHooks/useCheckEndsReached";

// helpers
import { getImgWithLogo } from "helpers/getCloudinaryImage";
import { goAxiosInstance } from "helpers/axiosInstance";

// style
import "./style.scss";
import { useTheme } from "components/ListingNew/ListingTheme";

export const ListingCollection = ({ ids }: any) => {
	const collectionRef = useRef(null);

	const { reachedRight, reachedLeft } = useCheckEndsReached({
		ref: collectionRef,
	});

	const listingCollectionData = useQuery(["listing__collection"], () =>
		goAxiosInstance({
			method: "GET",
			url: `https://go.saffronstays.com/api/listing-collection?ids=${ids}`,
		}),
	);

	const newData = listingCollectionData?.data?.data?.data;

	const Card = ({ data, theme = {} }: any) => {
		const img = getImgWithLogo({
			id: data.image,
			version: "9808092",
			quality: "42",
			width: "400",
			height: "400",
		});

		const url = `/collection/${data.slug}`;

		return (
			<a href={url} target="_blank" className="card" rel="noreferrer">
				<div className="card__top">
					<img src={img} alt={data.title} loading="lazy" />
				</div>
				<div className="card__bottom">
					<h1 style={{ color: theme?.primaryTextColor }}>{data.name}</h1>
				</div>
			</a>
		);
	};

	const theme = useTheme();
	if (!newData) {
		return null;
	}

	return (
		<div
			className="listing__collection__container"
			style={{ background: theme?.background }}
		>
			<div className="listing__collection">
				<div className="listing__collection__top">
					<HomeScrollContainerHeader
						// @ts-ignore
						slideLeft={() => (collectionRef.current.scrollLeft += -500)}
						// @ts-ignore
						slideRight={() => (collectionRef.current.scrollLeft += 500)}
						heading={"This home is a part of.."}
						reachedLeft={reachedLeft}
						reachedRight={reachedRight}
						theme={theme}
					/>
				</div>
				<div className="listing__collection__bottom" ref={collectionRef}>
					{newData?.map((v: any, i: number) => {
						return <Card data={v} key={v?.title} theme={theme} />;
					})}
				</div>
			</div>
		</div>
	);
};
